unit Dashboard.NonCompJobCard;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, VCL.TMSFNCButton, WEBLib.DBCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter,
  WEBLib.WebCtrls;

type
  TfrnNonCompleteJobCards = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebPanel4: TPanel;
    WebPanel5: TPanel;
    WebPanel6: TPanel;
    pnlJobcardTotal: TPanel;
    pnlCompJobCards: TPanel;
    pnlNonCompJobCards: TPanel;
    WebPanel10: TPanel;
    WebPanel11: TPanel;
    WebPanel12: TPanel;
    WebPanel13: TPanel;
    WebPanel14: TPanel;
    WebPanel15: TPanel;
    WebPanel16: TPanel;
    lblDate: TDBLabel;
    TMSFNCButton1: TTMSFNCButton;
    TMSFNCButton2: TTMSFNCButton;
    WebPanel17: TPanel;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    wcJobcardTotals: TXDataWebClient;
    wdsJobcardTotals: TXDataWebDataSet;
    dsJobcardTotal: TDataSource;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebDBLabel1: TDBLabel;
    WebDBLabel2: TDBLabel;
    WebDBLabel3: TDBLabel;
    WebDBLabel4: TDBLabel;
    WebDBLabel5: TDBLabel;
    WebDBLabel6: TDBLabel;
    WebDBLabel7: TDBLabel;
    WebDBLabel8: TDBLabel;
    WebDBLabel9: TDBLabel;
    wcJobcardDetailed: TXDataWebClient;
    wdsJobcardDetailed: TXDataWebDataSet;
    dsJobcardDetailed: TDataSource;
    wdsJobcardTotalsTotalJobcards: TIntegerField;
    wdsJobcardTotalsCompletedJobcards: TIntegerField;
    wdsJobcardTotalsNonCompletedJobcards: TIntegerField;
    wdsJobcardTotalsTotalCost: TFloatField;
    wdsJobcardTotalsCostCompletedJobCards: TFloatField;
    wdsJobcardTotalsCostNonCompletedJobCards: TFloatField;
    wdsJobcardTotalsTotalHours: TFloatField;
    wdsJobcardTotalsTotalCompleteHours: TFloatField;
    wdsJobcardTotalsTotalNonCompleteHours: TFloatField;
    dgdbaDetailed: TTMSFNCDataGridDatabaseAdapter;
    wdsJobcardDetailedJobcardNo: TStringField;
    wdsJobcardDetailedTruckRegNo: TStringField;
    wdsJobcardDetailedJobcardType: TStringField;
    wdsJobcardDetailedDownTime: TFloatField;
    wdsJobcardDetailedStartDate: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure TMSFNCButton1Click(Sender: TObject);
    procedure TMSFNCButton2Click(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
  private
    { Private declarations }

    wDay , wMonth , wYear : Word;

    procedure UpdateDateLabel;
    procedure LoadTotals;
    procedure LoadDetails;
    procedure ResizeTotals;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frnNonCompleteJobCards: TfrnNonCompleteJobCards;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  share.classes;

{ TfrnNonCompleteJobCards }

procedure TfrnNonCompleteJobCards.LoadDetails;
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
  begin
    LoadDetails;
  end;

  procedure OnSuccess(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadDetails;
      end
    else
      begin
        wdsJobcardDetailed.Close;
        wdsJobcardDetailed.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsJobcardDetailed.Open;

        console.log(GetJsonFromDataSet(wdsJobcardDetailed));
      end;
  end;

begin

  sJson := '{"Month":' + IntToStr(wMonth) + ',"Year":' + IntToStr(wYear) + '}';

  console.log(sJson);

  wcJobcardDetailed.RawInvoke('IdashboardService.Get_NonCompleteJobcard_Details',[sJson],@OnSuccess,@OnError);
end;

procedure TfrnNonCompleteJobCards.LoadTotals;
var
  sJson : String;

  procedure OnError(Error: TXDataClientError);
  begin
    LoadTotals;
  end;

  procedure OnSuccess(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadTotals;
      end
    else
      begin
        wdsJobcardTotals.Close;
        wdsJobcardTotals.SetJsonData(Response.Result);
        wdsJobcardTotals.Open;

        LoadDetails;
      end;
  end;

begin

  sJson := '{"Month":' + IntToStr(wMonth) + ',"Year":' + IntToStr(wYear) + '}';

  wcJobcardTotals.RawInvoke('IdashboardService.Get_NonCompleteJobcard_Totals',[sJson],@OnSuccess,@OnError);
end;

procedure TfrnNonCompleteJobCards.ResizeTotals;
begin
  pnlJobcardTotal.Width := Round(frnNonCompleteJobCards.Width/3);
end;

procedure TfrnNonCompleteJobCards.TMSFNCButton1Click(Sender: TObject);
begin
  wMonth := wMonth - 1;
  if wMonth < 1 then
    begin
      wMonth := 12;
      wYear := wYear -1;
    end;
  UpdateDateLabel;
  LoadTotals;
end;

procedure TfrnNonCompleteJobCards.TMSFNCButton2Click(Sender: TObject);
begin
  wMonth := wMonth + 1;
  if wMonth > 12 then
    begin
      wMonth := 1;
      wYear := wYear + 1;
    end;
  UpdateDateLabel;
  LoadTotals;

end;

procedure TfrnNonCompleteJobCards.UpdateDateLabel;
begin

  Case wMonth of
    1 : lblDate.Caption := 'JANUARY ' + IntToStr(wYear);
    2 : lblDate.Caption := 'FEBRUARY ' + IntToStr(wYear);
    3 : lblDate.Caption := 'MARCH ' + IntToStr(wYear);
    4 : lblDate.Caption := 'APRIL ' + IntToStr(wYear);
    5 : lblDate.Caption := 'MAY ' + IntToStr(wYear);
    6 : lblDate.Caption := 'JUNE ' + IntToStr(wYear);
    7 : lblDate.Caption := 'JULY ' + IntToStr(wYear);
    8 : lblDate.Caption := 'AUGUST ' + IntToStr(wYear);
    9 : lblDate.Caption := 'SEPTEMBER ' + IntToStr(wYear);
    10 : lblDate.Caption := 'OCTOBER ' + IntToStr(wYear);
    11 : lblDate.Caption := 'NOVEMBER ' + IntToStr(wYear);
    12 : lblDate.Caption := 'DECEMBER ' + IntToStr(wYear);
  End;

end;

procedure TfrnNonCompleteJobCards.WebFormResize(Sender: TObject);
begin
  pnlJobcardTotal.Width := Round(Window.InnerWidth / 3);
  pnlCompJobCards.Width := Round(Window.InnerWidth / 3);
  pnlNonCompJobCards.Width := Round(Window.InnerWidth / 3);

  WebPanel10.Width := Round(Window.InnerWidth / 3);
  WebPanel11.Width := Round(Window.InnerWidth / 3);
  WebPanel12.Width := Round(Window.InnerWidth / 3);

  WebPanel13.Width := Round(Window.InnerWidth / 3);
  WebPanel14.Width := Round(Window.InnerWidth / 3);
  WebPanel15.Width := Round(Window.InnerWidth / 3);

end;

procedure TfrnNonCompleteJobCards.WebFormShow(Sender: TObject);
begin
  DecodeDate(Now,wYear,wMonth,wDay);
  UpdateDateLabel;
  LoadTotals;

end;

procedure TfrnNonCompleteJobCards.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  pnlJobcardTotal := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebDBLabel1 := TDBLabel.Create(Self);
  pnlCompJobCards := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebDBLabel2 := TDBLabel.Create(Self);
  pnlNonCompJobCards := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebDBLabel3 := TDBLabel.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  WebPanel10 := TPanel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebDBLabel7 := TDBLabel.Create(Self);
  WebPanel11 := TPanel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebDBLabel8 := TDBLabel.Create(Self);
  WebPanel12 := TPanel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebDBLabel9 := TDBLabel.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  WebPanel13 := TPanel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebDBLabel6 := TDBLabel.Create(Self);
  WebPanel14 := TPanel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebDBLabel5 := TDBLabel.Create(Self);
  WebPanel15 := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebDBLabel4 := TDBLabel.Create(Self);
  WebPanel16 := TPanel.Create(Self);
  lblDate := TDBLabel.Create(Self);
  TMSFNCButton1 := TTMSFNCButton.Create(Self);
  TMSFNCButton2 := TTMSFNCButton.Create(Self);
  WebPanel17 := TPanel.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  dgdbaDetailed := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcJobcardTotals := TXDataWebClient.Create(Self);
  wdsJobcardTotals := TXDataWebDataSet.Create(Self);
  wdsJobcardTotalsTotalJobcards := TIntegerField.Create(Self);
  wdsJobcardTotalsCompletedJobcards := TIntegerField.Create(Self);
  wdsJobcardTotalsNonCompletedJobcards := TIntegerField.Create(Self);
  wdsJobcardTotalsTotalCost := TFloatField.Create(Self);
  wdsJobcardTotalsCostCompletedJobCards := TFloatField.Create(Self);
  wdsJobcardTotalsCostNonCompletedJobCards := TFloatField.Create(Self);
  wdsJobcardTotalsTotalHours := TFloatField.Create(Self);
  wdsJobcardTotalsTotalCompleteHours := TFloatField.Create(Self);
  wdsJobcardTotalsTotalNonCompleteHours := TFloatField.Create(Self);
  dsJobcardTotal := TDataSource.Create(Self);
  wcJobcardDetailed := TXDataWebClient.Create(Self);
  wdsJobcardDetailed := TXDataWebDataSet.Create(Self);
  wdsJobcardDetailedJobcardNo := TStringField.Create(Self);
  wdsJobcardDetailedTruckRegNo := TStringField.Create(Self);
  wdsJobcardDetailedJobcardType := TStringField.Create(Self);
  wdsJobcardDetailedStartDate := TStringField.Create(Self);
  wdsJobcardDetailedDownTime := TFloatField.Create(Self);
  dsJobcardDetailed := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  pnlJobcardTotal.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebDBLabel1.BeforeLoadDFMValues;
  pnlCompJobCards.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebDBLabel2.BeforeLoadDFMValues;
  pnlNonCompJobCards.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebDBLabel3.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  WebPanel10.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebDBLabel7.BeforeLoadDFMValues;
  WebPanel11.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebDBLabel8.BeforeLoadDFMValues;
  WebPanel12.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebDBLabel9.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  WebPanel13.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebDBLabel6.BeforeLoadDFMValues;
  WebPanel14.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebDBLabel5.BeforeLoadDFMValues;
  WebPanel15.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebDBLabel4.BeforeLoadDFMValues;
  WebPanel16.BeforeLoadDFMValues;
  lblDate.BeforeLoadDFMValues;
  TMSFNCButton1.BeforeLoadDFMValues;
  TMSFNCButton2.BeforeLoadDFMValues;
  WebPanel17.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  dgdbaDetailed.BeforeLoadDFMValues;
  wcJobcardTotals.BeforeLoadDFMValues;
  wdsJobcardTotals.BeforeLoadDFMValues;
  wdsJobcardTotalsTotalJobcards.BeforeLoadDFMValues;
  wdsJobcardTotalsCompletedJobcards.BeforeLoadDFMValues;
  wdsJobcardTotalsNonCompletedJobcards.BeforeLoadDFMValues;
  wdsJobcardTotalsTotalCost.BeforeLoadDFMValues;
  wdsJobcardTotalsCostCompletedJobCards.BeforeLoadDFMValues;
  wdsJobcardTotalsCostNonCompletedJobCards.BeforeLoadDFMValues;
  wdsJobcardTotalsTotalHours.BeforeLoadDFMValues;
  wdsJobcardTotalsTotalCompleteHours.BeforeLoadDFMValues;
  wdsJobcardTotalsTotalNonCompleteHours.BeforeLoadDFMValues;
  dsJobcardTotal.BeforeLoadDFMValues;
  wcJobcardDetailed.BeforeLoadDFMValues;
  wdsJobcardDetailed.BeforeLoadDFMValues;
  wdsJobcardDetailedJobcardNo.BeforeLoadDFMValues;
  wdsJobcardDetailedTruckRegNo.BeforeLoadDFMValues;
  wdsJobcardDetailedJobcardType.BeforeLoadDFMValues;
  wdsJobcardDetailedStartDate.BeforeLoadDFMValues;
  wdsJobcardDetailedDownTime.BeforeLoadDFMValues;
  dsJobcardDetailed.BeforeLoadDFMValues;
  try
    Name := 'frnNonCompleteJobCards';
    Width := 853;
    Height := 635;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 853;
    WebPanel1.Height := 635;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 853;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Non Complete Job Cards';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 120;
    WebPanel3.Width := 853;
    WebPanel3.Height := 181;
    WebPanel3.Align := alTop;
    WebPanel3.ChildOrder := 1;
    WebPanel3.TabOrder := 1;
    WebPanel4.SetParentComponent(WebPanel3);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 0;
    WebPanel4.Width := 853;
    WebPanel4.Height := 60;
    WebPanel4.Align := alTop;
    WebPanel4.TabOrder := 0;
    pnlJobcardTotal.SetParentComponent(WebPanel4);
    pnlJobcardTotal.Name := 'pnlJobcardTotal';
    pnlJobcardTotal.Left := 0;
    pnlJobcardTotal.Top := 0;
    pnlJobcardTotal.Width := 200;
    pnlJobcardTotal.Height := 60;
    pnlJobcardTotal.Align := alLeft;
    pnlJobcardTotal.Color := clSkyBlue;
    pnlJobcardTotal.TabOrder := 0;
    WebLabel1.SetParentComponent(pnlJobcardTotal);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 200;
    WebLabel1.Height := 21;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'Total JobCards:';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -16;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.SetParentComponent(pnlJobcardTotal);
    WebDBLabel1.Name := 'WebDBLabel1';
    WebDBLabel1.Left := 0;
    WebDBLabel1.Top := 21;
    WebDBLabel1.Width := 200;
    WebDBLabel1.Height := 39;
    WebDBLabel1.Align := alClient;
    WebDBLabel1.Alignment := taCenter;
    WebDBLabel1.Caption := 'WebDBLabel1';
    WebDBLabel1.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel1.Font.Color := clWindowText;
    WebDBLabel1.Font.Height := -13;
    WebDBLabel1.Font.Name := 'Segoe UI';
    WebDBLabel1.Font.Style := [fsBold];
    WebDBLabel1.HeightPercent := 100.000000000000000000;
    WebDBLabel1.ParentFont := False;
    WebDBLabel1.WidthPercent := 100.000000000000000000;
    WebDBLabel1.DataField := 'TotalJobcards';
    WebDBLabel1.DataSource := dsJobcardTotal;
    pnlCompJobCards.SetParentComponent(WebPanel4);
    pnlCompJobCards.Name := 'pnlCompJobCards';
    pnlCompJobCards.Left := 200;
    pnlCompJobCards.Top := 0;
    pnlCompJobCards.Width := 200;
    pnlCompJobCards.Height := 60;
    pnlCompJobCards.Align := alLeft;
    pnlCompJobCards.ChildOrder := 1;
    pnlCompJobCards.Color := clSkyBlue;
    pnlCompJobCards.TabOrder := 1;
    WebLabel2.SetParentComponent(pnlCompJobCards);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 0;
    WebLabel2.Top := 0;
    WebLabel2.Width := 200;
    WebLabel2.Height := 21;
    WebLabel2.Align := alTop;
    WebLabel2.Alignment := taCenter;
    WebLabel2.Caption := 'Complete JobCards:';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -16;
    WebLabel2.Font.Name := 'Segoe UI';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebDBLabel2.SetParentComponent(pnlCompJobCards);
    WebDBLabel2.Name := 'WebDBLabel2';
    WebDBLabel2.Left := 0;
    WebDBLabel2.Top := 21;
    WebDBLabel2.Width := 200;
    WebDBLabel2.Height := 39;
    WebDBLabel2.Align := alClient;
    WebDBLabel2.Alignment := taCenter;
    WebDBLabel2.Caption := 'WebDBLabel1';
    WebDBLabel2.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel2.Font.Color := clWindowText;
    WebDBLabel2.Font.Height := -13;
    WebDBLabel2.Font.Name := 'Segoe UI';
    WebDBLabel2.Font.Style := [fsBold];
    WebDBLabel2.HeightPercent := 100.000000000000000000;
    WebDBLabel2.ParentFont := False;
    WebDBLabel2.WidthPercent := 100.000000000000000000;
    WebDBLabel2.DataField := 'CompletedJobcards';
    WebDBLabel2.DataSource := dsJobcardTotal;
    pnlNonCompJobCards.SetParentComponent(WebPanel4);
    pnlNonCompJobCards.Name := 'pnlNonCompJobCards';
    pnlNonCompJobCards.Left := 400;
    pnlNonCompJobCards.Top := 0;
    pnlNonCompJobCards.Width := 200;
    pnlNonCompJobCards.Height := 60;
    pnlNonCompJobCards.Align := alLeft;
    pnlNonCompJobCards.ChildOrder := 2;
    pnlNonCompJobCards.Color := clSkyBlue;
    pnlNonCompJobCards.TabOrder := 2;
    WebLabel3.SetParentComponent(pnlNonCompJobCards);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 0;
    WebLabel3.Top := 0;
    WebLabel3.Width := 200;
    WebLabel3.Height := 21;
    WebLabel3.Align := alTop;
    WebLabel3.Alignment := taCenter;
    WebLabel3.Caption := 'Non Complete Jobcard:';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -16;
    WebLabel3.Font.Name := 'Segoe UI';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebDBLabel3.SetParentComponent(pnlNonCompJobCards);
    WebDBLabel3.Name := 'WebDBLabel3';
    WebDBLabel3.Left := 0;
    WebDBLabel3.Top := 21;
    WebDBLabel3.Width := 200;
    WebDBLabel3.Height := 39;
    WebDBLabel3.Align := alClient;
    WebDBLabel3.Alignment := taCenter;
    WebDBLabel3.Caption := 'WebDBLabel1';
    WebDBLabel3.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel3.Font.Color := clWindowText;
    WebDBLabel3.Font.Height := -13;
    WebDBLabel3.Font.Name := 'Segoe UI';
    WebDBLabel3.Font.Style := [fsBold];
    WebDBLabel3.HeightPercent := 100.000000000000000000;
    WebDBLabel3.ParentFont := False;
    WebDBLabel3.WidthPercent := 100.000000000000000000;
    WebDBLabel3.DataField := 'NonCompletedJobcards';
    WebDBLabel3.DataSource := dsJobcardTotal;
    WebPanel5.SetParentComponent(WebPanel3);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 0;
    WebPanel5.Top := 120;
    WebPanel5.Width := 853;
    WebPanel5.Height := 60;
    WebPanel5.Align := alTop;
    WebPanel5.Caption := 'WebPanel5';
    WebPanel5.ChildOrder := 1;
    WebPanel5.TabOrder := 1;
    WebPanel10.SetParentComponent(WebPanel5);
    WebPanel10.Name := 'WebPanel10';
    WebPanel10.Left := 0;
    WebPanel10.Top := 0;
    WebPanel10.Width := 200;
    WebPanel10.Height := 60;
    WebPanel10.Align := alLeft;
    WebPanel10.Color := clDarkturquoise;
    WebPanel10.TabOrder := 0;
    WebLabel7.SetParentComponent(WebPanel10);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 0;
    WebLabel7.Top := 0;
    WebLabel7.Width := 200;
    WebLabel7.Height := 21;
    WebLabel7.Align := alTop;
    WebLabel7.Alignment := taCenter;
    WebLabel7.Caption := 'Total Hours:';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -16;
    WebLabel7.Font.Name := 'Segoe UI';
    WebLabel7.Font.Style := [fsBold];
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebDBLabel7.SetParentComponent(WebPanel10);
    WebDBLabel7.Name := 'WebDBLabel7';
    WebDBLabel7.Left := 0;
    WebDBLabel7.Top := 21;
    WebDBLabel7.Width := 200;
    WebDBLabel7.Height := 39;
    WebDBLabel7.Align := alClient;
    WebDBLabel7.Alignment := taCenter;
    WebDBLabel7.Caption := 'WebDBLabel1';
    WebDBLabel7.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel7.Font.Color := clWindowText;
    WebDBLabel7.Font.Height := -13;
    WebDBLabel7.Font.Name := 'Segoe UI';
    WebDBLabel7.Font.Style := [fsBold];
    WebDBLabel7.HeightPercent := 100.000000000000000000;
    WebDBLabel7.ParentFont := False;
    WebDBLabel7.WidthPercent := 100.000000000000000000;
    WebDBLabel7.DataField := 'TotalHours';
    WebDBLabel7.DataSource := dsJobcardTotal;
    WebPanel11.SetParentComponent(WebPanel5);
    WebPanel11.Name := 'WebPanel11';
    WebPanel11.Left := 200;
    WebPanel11.Top := 0;
    WebPanel11.Width := 200;
    WebPanel11.Height := 60;
    WebPanel11.Align := alLeft;
    WebPanel11.ChildOrder := 1;
    WebPanel11.Color := clDarkturquoise;
    WebPanel11.TabOrder := 1;
    WebLabel8.SetParentComponent(WebPanel11);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 0;
    WebLabel8.Top := 0;
    WebLabel8.Width := 200;
    WebLabel8.Height := 21;
    WebLabel8.Align := alTop;
    WebLabel8.Alignment := taCenter;
    WebLabel8.Caption := 'Complete Hours:';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -16;
    WebLabel8.Font.Name := 'Segoe UI';
    WebLabel8.Font.Style := [fsBold];
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebDBLabel8.SetParentComponent(WebPanel11);
    WebDBLabel8.Name := 'WebDBLabel8';
    WebDBLabel8.Left := 0;
    WebDBLabel8.Top := 21;
    WebDBLabel8.Width := 200;
    WebDBLabel8.Height := 39;
    WebDBLabel8.Align := alClient;
    WebDBLabel8.Alignment := taCenter;
    WebDBLabel8.Caption := 'WebDBLabel1';
    WebDBLabel8.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel8.Font.Color := clWindowText;
    WebDBLabel8.Font.Height := -13;
    WebDBLabel8.Font.Name := 'Segoe UI';
    WebDBLabel8.Font.Style := [fsBold];
    WebDBLabel8.HeightPercent := 100.000000000000000000;
    WebDBLabel8.ParentFont := False;
    WebDBLabel8.WidthPercent := 100.000000000000000000;
    WebDBLabel8.DataField := 'TotalCompleteHours';
    WebDBLabel8.DataSource := dsJobcardTotal;
    WebPanel12.SetParentComponent(WebPanel5);
    WebPanel12.Name := 'WebPanel12';
    WebPanel12.Left := 400;
    WebPanel12.Top := 0;
    WebPanel12.Width := 200;
    WebPanel12.Height := 60;
    WebPanel12.Align := alLeft;
    WebPanel12.ChildOrder := 2;
    WebPanel12.Color := clDarkturquoise;
    WebPanel12.TabOrder := 2;
    WebLabel9.SetParentComponent(WebPanel12);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 0;
    WebLabel9.Top := 0;
    WebLabel9.Width := 200;
    WebLabel9.Height := 21;
    WebLabel9.Align := alTop;
    WebLabel9.Alignment := taCenter;
    WebLabel9.Caption := 'Non Complete Hours:';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -16;
    WebLabel9.Font.Name := 'Segoe UI';
    WebLabel9.Font.Style := [fsBold];
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.ParentFont := False;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebDBLabel9.SetParentComponent(WebPanel12);
    WebDBLabel9.Name := 'WebDBLabel9';
    WebDBLabel9.Left := 0;
    WebDBLabel9.Top := 21;
    WebDBLabel9.Width := 200;
    WebDBLabel9.Height := 39;
    WebDBLabel9.Align := alClient;
    WebDBLabel9.Alignment := taCenter;
    WebDBLabel9.Caption := 'WebDBLabel1';
    WebDBLabel9.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel9.Font.Color := clWindowText;
    WebDBLabel9.Font.Height := -13;
    WebDBLabel9.Font.Name := 'Segoe UI';
    WebDBLabel9.Font.Style := [fsBold];
    WebDBLabel9.HeightPercent := 100.000000000000000000;
    WebDBLabel9.ParentFont := False;
    WebDBLabel9.WidthPercent := 100.000000000000000000;
    WebDBLabel9.DataField := 'TotalNonCompleteHours';
    WebDBLabel9.DataSource := dsJobcardTotal;
    WebPanel6.SetParentComponent(WebPanel3);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 0;
    WebPanel6.Top := 60;
    WebPanel6.Width := 853;
    WebPanel6.Height := 60;
    WebPanel6.Align := alTop;
    WebPanel6.Caption := 'WebPanel6';
    WebPanel6.ChildOrder := 2;
    WebPanel6.TabOrder := 2;
    WebPanel13.SetParentComponent(WebPanel6);
    WebPanel13.Name := 'WebPanel13';
    WebPanel13.Left := 0;
    WebPanel13.Top := 0;
    WebPanel13.Width := 200;
    WebPanel13.Height := 60;
    WebPanel13.Align := alLeft;
    WebPanel13.Color := clAqua;
    WebPanel13.TabOrder := 0;
    WebLabel6.SetParentComponent(WebPanel13);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 0;
    WebLabel6.Top := 0;
    WebLabel6.Width := 200;
    WebLabel6.Height := 21;
    WebLabel6.Align := alTop;
    WebLabel6.Alignment := taCenter;
    WebLabel6.Caption := 'Total Cost:';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -16;
    WebLabel6.Font.Name := 'Segoe UI';
    WebLabel6.Font.Style := [fsBold];
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebDBLabel6.SetParentComponent(WebPanel13);
    WebDBLabel6.Name := 'WebDBLabel6';
    WebDBLabel6.Left := 0;
    WebDBLabel6.Top := 21;
    WebDBLabel6.Width := 200;
    WebDBLabel6.Height := 39;
    WebDBLabel6.Align := alClient;
    WebDBLabel6.Alignment := taCenter;
    WebDBLabel6.Caption := 'WebDBLabel1';
    WebDBLabel6.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel6.Font.Color := clWindowText;
    WebDBLabel6.Font.Height := -13;
    WebDBLabel6.Font.Name := 'Segoe UI';
    WebDBLabel6.Font.Style := [fsBold];
    WebDBLabel6.HeightPercent := 100.000000000000000000;
    WebDBLabel6.ParentFont := False;
    WebDBLabel6.WidthPercent := 100.000000000000000000;
    WebDBLabel6.DataField := 'TotalCost';
    WebDBLabel6.DataSource := dsJobcardTotal;
    WebPanel14.SetParentComponent(WebPanel6);
    WebPanel14.Name := 'WebPanel14';
    WebPanel14.Left := 200;
    WebPanel14.Top := 0;
    WebPanel14.Width := 200;
    WebPanel14.Height := 60;
    WebPanel14.Align := alLeft;
    WebPanel14.ChildOrder := 1;
    WebPanel14.Color := clAqua;
    WebPanel14.TabOrder := 1;
    WebLabel5.SetParentComponent(WebPanel14);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 0;
    WebLabel5.Top := 0;
    WebLabel5.Width := 200;
    WebLabel5.Height := 21;
    WebLabel5.Align := alTop;
    WebLabel5.Alignment := taCenter;
    WebLabel5.Caption := 'Total Cost Completed:';
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -16;
    WebLabel5.Font.Name := 'Segoe UI';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebDBLabel5.SetParentComponent(WebPanel14);
    WebDBLabel5.Name := 'WebDBLabel5';
    WebDBLabel5.Left := 0;
    WebDBLabel5.Top := 21;
    WebDBLabel5.Width := 200;
    WebDBLabel5.Height := 39;
    WebDBLabel5.Align := alClient;
    WebDBLabel5.Alignment := taCenter;
    WebDBLabel5.Caption := 'WebDBLabel1';
    WebDBLabel5.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel5.Font.Color := clWindowText;
    WebDBLabel5.Font.Height := -13;
    WebDBLabel5.Font.Name := 'Segoe UI';
    WebDBLabel5.Font.Style := [fsBold];
    WebDBLabel5.HeightPercent := 100.000000000000000000;
    WebDBLabel5.ParentFont := False;
    WebDBLabel5.WidthPercent := 100.000000000000000000;
    WebDBLabel5.DataField := 'CostCompletedJobCards';
    WebDBLabel5.DataSource := dsJobcardTotal;
    WebPanel15.SetParentComponent(WebPanel6);
    WebPanel15.Name := 'WebPanel15';
    WebPanel15.Left := 400;
    WebPanel15.Top := 0;
    WebPanel15.Width := 200;
    WebPanel15.Height := 60;
    WebPanel15.Align := alLeft;
    WebPanel15.ChildOrder := 2;
    WebPanel15.Color := clAqua;
    WebPanel15.TabOrder := 2;
    WebLabel4.SetParentComponent(WebPanel15);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 0;
    WebLabel4.Top := 0;
    WebLabel4.Width := 200;
    WebLabel4.Height := 21;
    WebLabel4.Align := alTop;
    WebLabel4.Alignment := taCenter;
    WebLabel4.Caption := 'Total Cost Non Completed:';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -16;
    WebLabel4.Font.Name := 'Segoe UI';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebDBLabel4.SetParentComponent(WebPanel15);
    WebDBLabel4.Name := 'WebDBLabel4';
    WebDBLabel4.Left := 0;
    WebDBLabel4.Top := 21;
    WebDBLabel4.Width := 200;
    WebDBLabel4.Height := 39;
    WebDBLabel4.Align := alClient;
    WebDBLabel4.Alignment := taCenter;
    WebDBLabel4.Caption := 'WebDBLabel1';
    WebDBLabel4.Font.Charset := DEFAULT_CHARSET;
    WebDBLabel4.Font.Color := clWindowText;
    WebDBLabel4.Font.Height := -13;
    WebDBLabel4.Font.Name := 'Segoe UI';
    WebDBLabel4.Font.Style := [fsBold];
    WebDBLabel4.HeightPercent := 100.000000000000000000;
    WebDBLabel4.ParentFont := False;
    WebDBLabel4.WidthPercent := 100.000000000000000000;
    WebDBLabel4.DataField := 'CostNonCompletedJobCards';
    WebDBLabel4.DataSource := dsJobcardTotal;
    WebPanel16.SetParentComponent(WebPanel1);
    WebPanel16.Name := 'WebPanel16';
    WebPanel16.Left := 0;
    WebPanel16.Top := 60;
    WebPanel16.Width := 853;
    WebPanel16.Height := 60;
    WebPanel16.Align := alTop;
    WebPanel16.ChildOrder := 2;
    WebPanel16.Color := clBlack;
    WebPanel16.TabOrder := 2;
    lblDate.SetParentComponent(WebPanel16);
    lblDate.Name := 'lblDate';
    lblDate.Left := 231;
    lblDate.Top := 24;
    lblDate.Width := 45;
    lblDate.Height := 17;
    lblDate.Alignment := taCenter;
    lblDate.Caption := 'lblDate';
    lblDate.Font.Charset := DEFAULT_CHARSET;
    lblDate.Font.Color := clWhite;
    lblDate.Font.Height := -13;
    lblDate.Font.Name := 'Segoe UI';
    lblDate.Font.Style := [fsBold];
    lblDate.HeightPercent := 100.000000000000000000;
    lblDate.ParentFont := False;
    lblDate.WidthPercent := 100.000000000000000000;
    TMSFNCButton1.SetParentComponent(WebPanel16);
    TMSFNCButton1.Name := 'TMSFNCButton1';
    TMSFNCButton1.Left := 176;
    TMSFNCButton1.Top := 20;
    TMSFNCButton1.Width := 50;
    TMSFNCButton1.Height := 25;
    TMSFNCButton1.Font.Charset := DEFAULT_CHARSET;
    TMSFNCButton1.Font.Color := clWindowText;
    TMSFNCButton1.Font.Height := -12;
    TMSFNCButton1.Font.Name := 'Segoe UI';
    TMSFNCButton1.Font.Style := [];
    TMSFNCButton1.Text := '<';
    TMSFNCButton1.TabOrder := 0;
    SetEvent(TMSFNCButton1, Self, 'OnClick', 'TMSFNCButton1Click');
    TMSFNCButton2.SetParentComponent(WebPanel16);
    TMSFNCButton2.Name := 'TMSFNCButton2';
    TMSFNCButton2.Left := 373;
    TMSFNCButton2.Top := 20;
    TMSFNCButton2.Width := 57;
    TMSFNCButton2.Height := 25;
    TMSFNCButton2.Font.Charset := DEFAULT_CHARSET;
    TMSFNCButton2.Font.Color := clWindowText;
    TMSFNCButton2.Font.Height := -12;
    TMSFNCButton2.Font.Name := 'Segoe UI';
    TMSFNCButton2.Font.Style := [];
    TMSFNCButton2.Text := '>';
    TMSFNCButton2.TabOrder := 1;
    SetEvent(TMSFNCButton2, Self, 'OnClick', 'TMSFNCButton2Click');
    WebPanel17.SetParentComponent(WebPanel1);
    WebPanel17.Name := 'WebPanel17';
    WebPanel17.Left := 0;
    WebPanel17.Top := 301;
    WebPanel17.Width := 853;
    WebPanel17.Height := 334;
    WebPanel17.Align := alClient;
    WebPanel17.ChildOrder := 3;
    WebPanel17.TabOrder := 3;
    TMSFNCDataGrid1.SetParentComponent(WebPanel17);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 0;
    TMSFNCDataGrid1.Width := 853;
    TMSFNCDataGrid1.Height := 334;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 0;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := dgdbaDetailed;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 5;
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'JobcardNo';
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TruckRegNo';
      Width := 125.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'JobcardType';
      Width := 150.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'StartDate';
      Width := 100.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'DownTime';
      Width := 125.000000000000000000;
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('Dashboard.NonCompJobCard.WebPanel17.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('Dashboard.NonCompJobCard.WebPanel17.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('Dashboard.NonCompJobCard.WebPanel17.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('Dashboard.NonCompJobCard.WebPanel17.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('Dashboard.NonCompJobCard.WebPanel17.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('Dashboard.NonCompJobCard.WebPanel17.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('Dashboard.NonCompJobCard.WebPanel17.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('Dashboard.NonCompJobCard.WebPanel17.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('Dashboard.NonCompJobCard.WebPanel17.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    TMSFNCDataGrid1.RowCount := 1;
    dgdbaDetailed.SetParentComponent(TMSFNCDataGrid1);
    dgdbaDetailed.Name := 'dgdbaDetailed';
    dgdbaDetailed.Left := 320;
    dgdbaDetailed.Top := 144;
    dgdbaDetailed.Width := 26;
    dgdbaDetailed.Height := 26;
    dgdbaDetailed.Visible := True;
    dgdbaDetailed.Columns.Clear;
    with dgdbaDetailed.Columns.Add do
    begin
      FieldName := 'JobcardNo';
      Header := 'JobcardNo';
      AutoCreated := False;
    end;
    with dgdbaDetailed.Columns.Add do
    begin
      FieldName := 'TruckRegNo';
      Header := 'TruckRegNo';
      AutoCreated := False;
    end;
    with dgdbaDetailed.Columns.Add do
    begin
      FieldName := 'JobcardType';
      Header := 'JobcardType';
      AutoCreated := False;
    end;
    with dgdbaDetailed.Columns.Add do
    begin
      FieldName := 'StartDate';
      Header := 'StartDate';
      AutoCreated := False;
    end;
    with dgdbaDetailed.Columns.Add do
    begin
      FieldName := 'DownTime';
      Header := 'DownTime';
      AutoCreated := False;
    end;
    dgdbaDetailed.DataSource := dsJobcardDetailed;
    wcJobcardTotals.SetParentComponent(Self);
    wcJobcardTotals.Name := 'wcJobcardTotals';
    wcJobcardTotals.Connection := dmData.dbConnect;
    wcJobcardTotals.Left := 56;
    wcJobcardTotals.Top := 124;
    wdsJobcardTotals.SetParentComponent(Self);
    wdsJobcardTotals.Name := 'wdsJobcardTotals';
    wdsJobcardTotals.Connection := dmData.dbConnect;
    wdsJobcardTotals.Left := 168;
    wdsJobcardTotals.Top := 124;
    wdsJobcardTotalsTotalJobcards.SetParentComponent(wdsJobcardTotals);
    wdsJobcardTotalsTotalJobcards.Name := 'wdsJobcardTotalsTotalJobcards';
    wdsJobcardTotalsTotalJobcards.FieldName := 'TotalJobcards';
    wdsJobcardTotalsTotalJobcards.DisplayFormat := '#,##0';
    wdsJobcardTotalsCompletedJobcards.SetParentComponent(wdsJobcardTotals);
    wdsJobcardTotalsCompletedJobcards.Name := 'wdsJobcardTotalsCompletedJobcards';
    wdsJobcardTotalsCompletedJobcards.FieldName := 'CompletedJobcards';
    wdsJobcardTotalsCompletedJobcards.DisplayFormat := '#,##0';
    wdsJobcardTotalsNonCompletedJobcards.SetParentComponent(wdsJobcardTotals);
    wdsJobcardTotalsNonCompletedJobcards.Name := 'wdsJobcardTotalsNonCompletedJobcards';
    wdsJobcardTotalsNonCompletedJobcards.FieldName := 'NonCompletedJobcards';
    wdsJobcardTotalsNonCompletedJobcards.DisplayFormat := '#,##0';
    wdsJobcardTotalsTotalCost.SetParentComponent(wdsJobcardTotals);
    wdsJobcardTotalsTotalCost.Name := 'wdsJobcardTotalsTotalCost';
    wdsJobcardTotalsTotalCost.FieldName := 'TotalCost';
    wdsJobcardTotalsTotalCost.DisplayFormat := '#,##0.00';
    wdsJobcardTotalsCostCompletedJobCards.SetParentComponent(wdsJobcardTotals);
    wdsJobcardTotalsCostCompletedJobCards.Name := 'wdsJobcardTotalsCostCompletedJobCards';
    wdsJobcardTotalsCostCompletedJobCards.FieldName := 'CostCompletedJobCards';
    wdsJobcardTotalsCostCompletedJobCards.DisplayFormat := '#,##0.00';
    wdsJobcardTotalsCostNonCompletedJobCards.SetParentComponent(wdsJobcardTotals);
    wdsJobcardTotalsCostNonCompletedJobCards.Name := 'wdsJobcardTotalsCostNonCompletedJobCards';
    wdsJobcardTotalsCostNonCompletedJobCards.FieldName := 'CostNonCompletedJobCards';
    wdsJobcardTotalsCostNonCompletedJobCards.DisplayFormat := '#,##0.00';
    wdsJobcardTotalsTotalHours.SetParentComponent(wdsJobcardTotals);
    wdsJobcardTotalsTotalHours.Name := 'wdsJobcardTotalsTotalHours';
    wdsJobcardTotalsTotalHours.FieldName := 'TotalHours';
    wdsJobcardTotalsTotalHours.DisplayFormat := '#,##0.00';
    wdsJobcardTotalsTotalCompleteHours.SetParentComponent(wdsJobcardTotals);
    wdsJobcardTotalsTotalCompleteHours.Name := 'wdsJobcardTotalsTotalCompleteHours';
    wdsJobcardTotalsTotalCompleteHours.FieldName := 'TotalCompleteHours';
    wdsJobcardTotalsTotalCompleteHours.DisplayFormat := '#,##0.00';
    wdsJobcardTotalsTotalNonCompleteHours.SetParentComponent(wdsJobcardTotals);
    wdsJobcardTotalsTotalNonCompleteHours.Name := 'wdsJobcardTotalsTotalNonCompleteHours';
    wdsJobcardTotalsTotalNonCompleteHours.FieldName := 'TotalNonCompleteHours';
    wdsJobcardTotalsTotalNonCompleteHours.DisplayFormat := '#,##0.00';
    dsJobcardTotal.SetParentComponent(Self);
    dsJobcardTotal.Name := 'dsJobcardTotal';
    dsJobcardTotal.DataSet := wdsJobcardTotals;
    dsJobcardTotal.Left := 272;
    dsJobcardTotal.Top := 124;
    wcJobcardDetailed.SetParentComponent(Self);
    wcJobcardDetailed.Name := 'wcJobcardDetailed';
    wcJobcardDetailed.Connection := dmData.dbConnect;
    wcJobcardDetailed.Left := 96;
    wcJobcardDetailed.Top := 445;
    wdsJobcardDetailed.SetParentComponent(Self);
    wdsJobcardDetailed.Name := 'wdsJobcardDetailed';
    wdsJobcardDetailed.Connection := dmData.dbConnect;
    wdsJobcardDetailed.Left := 168;
    wdsJobcardDetailed.Top := 445;
    wdsJobcardDetailedJobcardNo.SetParentComponent(wdsJobcardDetailed);
    wdsJobcardDetailedJobcardNo.Name := 'wdsJobcardDetailedJobcardNo';
    wdsJobcardDetailedJobcardNo.FieldName := 'JobcardNo';
    wdsJobcardDetailedTruckRegNo.SetParentComponent(wdsJobcardDetailed);
    wdsJobcardDetailedTruckRegNo.Name := 'wdsJobcardDetailedTruckRegNo';
    wdsJobcardDetailedTruckRegNo.FieldName := 'TruckRegNo';
    wdsJobcardDetailedJobcardType.SetParentComponent(wdsJobcardDetailed);
    wdsJobcardDetailedJobcardType.Name := 'wdsJobcardDetailedJobcardType';
    wdsJobcardDetailedJobcardType.FieldName := 'JobcardType';
    wdsJobcardDetailedStartDate.SetParentComponent(wdsJobcardDetailed);
    wdsJobcardDetailedStartDate.Name := 'wdsJobcardDetailedStartDate';
    wdsJobcardDetailedStartDate.FieldName := 'StartDate';
    wdsJobcardDetailedDownTime.SetParentComponent(wdsJobcardDetailed);
    wdsJobcardDetailedDownTime.Name := 'wdsJobcardDetailedDownTime';
    wdsJobcardDetailedDownTime.FieldName := 'DownTime';
    wdsJobcardDetailedDownTime.DisplayFormat := '#,##0.00';
    dsJobcardDetailed.SetParentComponent(Self);
    dsJobcardDetailed.Name := 'dsJobcardDetailed';
    dsJobcardDetailed.DataSet := wdsJobcardDetailed;
    dsJobcardDetailed.Left := 232;
    dsJobcardDetailed.Top := 445;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    pnlJobcardTotal.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebDBLabel1.AfterLoadDFMValues;
    pnlCompJobCards.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebDBLabel2.AfterLoadDFMValues;
    pnlNonCompJobCards.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebDBLabel3.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    WebPanel10.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebDBLabel7.AfterLoadDFMValues;
    WebPanel11.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebDBLabel8.AfterLoadDFMValues;
    WebPanel12.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebDBLabel9.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    WebPanel13.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebDBLabel6.AfterLoadDFMValues;
    WebPanel14.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebDBLabel5.AfterLoadDFMValues;
    WebPanel15.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebDBLabel4.AfterLoadDFMValues;
    WebPanel16.AfterLoadDFMValues;
    lblDate.AfterLoadDFMValues;
    TMSFNCButton1.AfterLoadDFMValues;
    TMSFNCButton2.AfterLoadDFMValues;
    WebPanel17.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    dgdbaDetailed.AfterLoadDFMValues;
    wcJobcardTotals.AfterLoadDFMValues;
    wdsJobcardTotals.AfterLoadDFMValues;
    wdsJobcardTotalsTotalJobcards.AfterLoadDFMValues;
    wdsJobcardTotalsCompletedJobcards.AfterLoadDFMValues;
    wdsJobcardTotalsNonCompletedJobcards.AfterLoadDFMValues;
    wdsJobcardTotalsTotalCost.AfterLoadDFMValues;
    wdsJobcardTotalsCostCompletedJobCards.AfterLoadDFMValues;
    wdsJobcardTotalsCostNonCompletedJobCards.AfterLoadDFMValues;
    wdsJobcardTotalsTotalHours.AfterLoadDFMValues;
    wdsJobcardTotalsTotalCompleteHours.AfterLoadDFMValues;
    wdsJobcardTotalsTotalNonCompleteHours.AfterLoadDFMValues;
    dsJobcardTotal.AfterLoadDFMValues;
    wcJobcardDetailed.AfterLoadDFMValues;
    wdsJobcardDetailed.AfterLoadDFMValues;
    wdsJobcardDetailedJobcardNo.AfterLoadDFMValues;
    wdsJobcardDetailedTruckRegNo.AfterLoadDFMValues;
    wdsJobcardDetailedJobcardType.AfterLoadDFMValues;
    wdsJobcardDetailedStartDate.AfterLoadDFMValues;
    wdsJobcardDetailedDownTime.AfterLoadDFMValues;
    dsJobcardDetailed.AfterLoadDFMValues;
  end;
end;

end.